/**
 * @packageDocumentation
 * @module HackerAPI.Search.Airport
 */
import { parseDate } from "../../utils/utils";
/**
 * Data container for aiport search results
 * @struct
 */
var Airport = /** @class */ (function () {
    /**
     * Instantiates a new Airport instance
     * @constructor
     * @param airport
     */
    function Airport(_a) {
        var code = _a.code, name = _a.name, country_code = _a.country_code, countryCode = _a.countryCode, municipality = _a.municipality, keywords = _a.keywords, is_operational = _a.is_operational, isOperational = _a.isOperational, latitude = _a.latitude, longitude = _a.longitude, link = _a.link, created_at = _a.created_at, createdAt = _a.createdAt, updated_at = _a.updated_at, updatedAt = _a.updatedAt;
        /**
         * The 3 letter code of the airport
         * @type { string }
         */
        this.code = code;
        /**
         * The name of the airport
         * @type { string }
         */
        this.name = name;
        /**
         * The 2 letter country code of the airport
         * @type { string }
         */
        this.countryCode = country_code || countryCode;
        /**
         * The general region of the airport
         * @type { string }
         */
        this.municipality = municipality;
        /**
         * Comma-separated list of keywords
         * @type { string }
         */
        this.keywords = keywords || "";
        /**
         * Whether or not the airport is operational
         * @type { boolean }
         */
        this.isOperational = is_operational || isOperational || false;
        /**
         * The latitude of the airport
         * @type { number }
         */
        this.latitude = latitude;
        /**
         * The longitude of the airport
         * @type { number }
         */
        this.longitude = longitude;
        /**
         * Link to the website of the airport
         * @type { string }
         */
        this.link = link;
        /**
         * When the airport was created in the database
         * @type { Date }
         */
        this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the airport was last updated in the database
         * @type { Date }
         */
        this.updatedAt = parseDate(updated_at || updatedAt);
    }
    return Airport;
}());
export default Airport;
//# sourceMappingURL=airport.js.map